import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const faqList = [
  {
    q: '51动漫网是什么？',
    a: '51动漫是一个专注于国产动漫在线观看与信息聚合的平台。我们每日更新热门番剧、经典国漫资源，为动漫爱好者提供便捷的观看导航与最新资讯。无论是最新上线的年番大作，还是经典怀旧的国漫作品，你都能在51动漫找到对应的观看路径。',
  },
  {
    q: '51动漫是否需要注册会员？',
    a: '51动漫作为动漫资源聚合导航平台，目前完全免费开放给所有动漫爱好者使用。无需注册、无需登录，即可浏览全部动漫内容。我们致力于让每一位动漫迷都能方便快捷地找到自己喜欢的作品。',
  },
  {
    q: '动漫资源多久更新一次？',
    a: '我们与各大视频平台保持同步更新节奏。国产动漫年番作品通常每周更新一集，具体更新时间以各平台官方排期为准。我们会在动漫上线后第一时间更新网站信息，确保你能看到最新的剧集列表。',
  },
  {
    q: '如何在51动漫找到想看的动漫？',
    a: '你可以通过首页的热门推荐、每日更新日历、分类导航等多种方式找到感兴趣的作品。也可以使用搜索功能输入动漫名称进行查找。每部动漫都有详细的介绍页面，包含剧情简介、剧集列表和评分信息。',
  },
  {
    q: '为什么有些动漫显示"即将上线"？',
    a: '部分动漫内容正在筹备收录中。我们正在不断扩大动漫资源的覆盖面，如果你有想要收录的动漫作品，欢迎通过商务合作渠道与我们联系推荐，我们将优先考虑用户需求量大的作品。',
  },
  {
    q: '51动漫自己制作动漫内容吗？',
    a: '51动漫是动漫资源导航与信息聚合平台，本身不制作或托管任何视频内容。我们提供的是动漫作品的信息介绍、观看导航和资源索引服务，帮助用户快速找到各大视频平台上的正版动漫资源。',
  },
  {
    q: '遇到网站问题如何反馈？',
    a: '如果你在使用过程中遇到任何问题，或有任何建议和意见，欢迎通过本页面的商务合作联系表单与我们沟通。我们会在收到反馈后尽快处理，不断优化用户体验。',
  },
  {
    q: '可以在手机上使用51动漫吗？',
    a: '当然可以！51动漫网站采用响应式设计，完美适配手机、平板和电脑等各类设备。无论你在哪里，只需打开浏览器访问51动漫，即可获得流畅的浏览体验。我们也在积极规划移动端专属优化方案。',
  },
];

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    document.title = '关于我们 | 51动漫 - 国产动漫在线观看平台';
    document.querySelector('meta[name="description"]')?.setAttribute('content', '51动漫是国内领先的国产动漫在线观看平台。了解51动漫的品牌故事、平台数据、商务合作信息与常见问题。');
    document.querySelector('meta[name="keywords"]')?.setAttribute('content', '51动漫,关于我们,动漫平台,商务合作,国漫在线,动漫资源平台');
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) existingScript.remove();

    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://heiliaochigua.cn/' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://heiliaochigua.cn/about' },
          ],
        },
        {
          '@type': 'AboutPage',
          name: '关于我们 | 51动漫',
          description: '了解51动漫的品牌故事、平台数据、商务合作信息与常见问题',
          url: 'http://heiliaochigua.cn/about',
          isPartOf: { '@id': 'http://heiliaochigua.cn/#website' },
        },
        {
          '@type': 'FAQPage',
          mainEntity: faqList.map((faq) => ({
            '@type': 'Question',
            name: faq.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.a,
            },
          })),
        },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }
    try {
      const response = await fetch('http://heiliaochigua.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          name: formData.get('name') as string,
          email: formData.get('email') as string,
          company: formData.get('company') as string,
          message: formData.get('message') as string,
        }).toString(),
      });
      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setFormStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <main className="min-h-screen">
      {/* Hero */}
      <section className="relative w-full h-[320px] md:h-[400px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20creative%20animation%20studio%20workspace%20with%20warm%20ambient%20lighting%2C%20artist%20desk%20with%20sketches%20and%20digital%20tablets%2C%20soft%20natural%20light%20from%20large%20windows%2C%20stylized%20illustration%20aesthetic%20with%20warm%20orange%20and%20cream%20tones%2C%20clean%20serene%20atmosphere%2C%20editorial%20composition&width=1600&height=500&seq=about-hero-01&orientation=landscape"
          alt="关于51动漫"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-6 lg:px-12">
            <nav className="flex items-center gap-2 text-xs text-background-100/70 mb-4" aria-label="面包屑导航">
              <Link to="/" className="hover:text-background-50 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-background-100 font-medium">关于我们</span>
            </nav>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-background-50">
              关于 51动漫
            </h1>
            <p className="text-sm md:text-base text-background-200 mt-3 max-w-xl">
              国内领先的国产动漫在线观看与信息聚合平台，为每一位动漫爱好者提供最便捷的追番体验
            </p>
          </div>
        </div>
      </section>

      {/* Brand Story */}
      <section className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-50">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[45%]">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">
              让每一部好国漫<br />都被看见
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              51动漫诞生于国产动漫蓬勃发展的时代。我们注意到，虽然每年都有大量优秀的国产动漫作品问世，但动漫爱好者们常常面临"信息分散、找不到观看入口、追更不便"等问题。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              于是，51动漫应运而生。我们致力于打造一个一站式国产动漫信息聚合平台，帮助每一位动漫爱好者快速找到想看的作品、追踪最新的更新动态。从热门年番到小众精品，从玄幻仙侠到科幻都市，51动漫努力覆盖国产动漫的每一个角落。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              我们的愿景是成为国产动漫领域最值得信赖的信息导航平台，让国漫之美被更多人发现和欣赏。支持国漫，从51动漫开始。
            </p>
          </div>
          <div className="lg:w-[55%]">
            <div className="w-full h-[300px] md:h-[360px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20creative%20studio%20scene%20with%20Chinese%20animation%20artwork%20displayed%20on%20walls%2C%20designers%20collaborating%20around%20wooden%20table%20with%20sketches%20and%20tablets%2C%20natural%20window%20light%2C%20cozy%20inspiring%20atmosphere%2C%20stylized%20illustration%2C%20warm%20cream%20and%20amber%20tones%2C%20clean%20composition&width=800&height=500&seq=about-story-01&orientation=landscape"
                alt="51动漫团队"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Platform Stats */}
      <section className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-100">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            平台数据
          </h2>
          <p className="text-sm text-foreground-500">51动漫不断成长，用心服务每一位动漫爱好者</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {[
            { value: '500+', label: '收录动漫', icon: 'ri-movie-2-line', color: 'text-primary-600' },
            { value: '50万+', label: '月活跃用户', icon: 'ri-user-heart-line', color: 'text-accent-600' },
            { value: '3年+', label: '持续运营', icon: 'ri-calendar-check-line', color: 'text-secondary-600' },
            { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line', color: 'text-primary-600' },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50">
              <div className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-2xl ${stat.color}`}></i>
              </div>
              <p className={`text-2xl md:text-3xl font-heading ${stat.color} mb-1`}>{stat.value}</p>
              <p className="text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Timeline / Milestones */}
      <section className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-50">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            发展历程
          </span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            我们走过的路
          </h2>
        </div>

        <div className="max-w-2xl mx-auto">
          {[
            { year: '2026', title: '平台全面升级', desc: '网站全新改版上线，新增每日更新日历、热门推荐等核心功能，用户体验大幅提升。收录国产动漫超过500部，月活跃用户突破50万。' },
            { year: '2025', title: '快速成长期', desc: '平台用户量快速增长，内容覆盖面从国产动漫扩展到日本动漫和剧场版动画。建立与多家视频平台的合作关系。' },
            { year: '2024', title: '平台正式上线', desc: '51动漫网正式上线运营，以国产动漫为核心内容方向，为动漫爱好者提供在线观看导航与最新资讯服务。' },
          ].map((item, idx) => (
            <div key={item.year} className="flex gap-6 pb-10 last:pb-0">
              <div className="flex flex-col items-center">
                <div className={`w-3 h-3 rounded-full ${idx === 0 ? 'bg-primary-500' : 'bg-foreground-300'}`}></div>
                {idx < 2 && <div className="w-px flex-1 bg-background-300 mt-1"></div>}
              </div>
              <div className="flex-1 pb-2">
                <span className={`text-xs font-medium ${idx === 0 ? 'text-primary-600' : 'text-foreground-500'}`}>
                  {item.year}
                </span>
                <h3 className="text-base font-heading text-foreground-950 mt-0.5">{item.title}</h3>
                <p className="text-sm text-foreground-600 mt-1.5 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Business Cooperation + Contact */}
      <section id="contact" className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-100">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[45%]">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
              商务合作
            </span>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">
              与我们合作
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              51动漫欢迎各类商务合作洽谈。无论你是视频平台方、动漫制作公司、版权方，还是广告合作方和品牌赞助商，都欢迎与我们联系。
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-accent-700"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">合作邮箱</p>
                  <p className="text-xs text-foreground-500">hello@heiliaochigua.cn</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-secondary-700"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">合作热线</p>
                  <p className="text-xs text-foreground-500">010-8888-6666（工作日 9:00-18:00）</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-primary-700"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">公司地址</p>
                  <p className="text-xs text-foreground-500">北京市朝阳区建国路88号动漫产业大厦15层</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-5 rounded-lg bg-accent-100/60">
              <h3 className="text-sm font-heading text-accent-800 mb-2">合作方向</h3>
              <div className="flex flex-wrap gap-2">
                {['内容合作', '版权授权', '广告投放', '品牌赞助', '联合推广', '技术合作'].map((item) => (
                  <span key={item} className="px-3 py-1 rounded-full text-xs bg-background-50 text-foreground-700">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:w-[55%]">
            <div className="bg-background-50 rounded-lg p-6 md:p-8">
              <h3 className="text-lg font-heading text-foreground-950 mb-6">发送合作咨询</h3>

              <form onSubmit={handleSubmit}>
                <div className="space-y-4">
                  <div>
                    <label htmlFor="coop-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      您的姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="coop-name"
                      type="text"
                      name="name"
                      required
                      placeholder="请输入您的姓名"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-colors"
                    />
                  </div>

                  <div>
                    <label htmlFor="coop-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      联系邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="coop-email"
                      type="email"
                      name="email"
                      required
                      placeholder="请输入您的邮箱"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-colors"
                    />
                  </div>

                  <div>
                    <label htmlFor="coop-company" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      公司/机构名称
                    </label>
                    <input
                      id="coop-company"
                      type="text"
                      name="company"
                      placeholder="请输入您的公司或机构名称"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-colors"
                    />
                  </div>

                  <div>
                    <label htmlFor="coop-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      合作意向 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      id="coop-message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      placeholder="请描述您的合作意向或咨询内容（最多500字）"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-colors resize-none"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">限500字以内</p>
                  </div>

                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />

                  <button
                    type="submit"
                    className="w-full py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    提交咨询
                  </button>
                </div>

                {formStatus === 'success' && (
                  <div className="mt-4 p-4 rounded-lg bg-accent-100/60">
                    <p className="text-sm text-accent-800">
                      <i className="ri-check-line mr-1"></i>
                      感谢您的咨询！我们将在 1-3 个工作日内与您联系。
                    </p>
                  </div>
                )}
                {formStatus === 'error' && (
                  <div className="mt-4 p-4 rounded-lg bg-primary-100/60">
                    <p className="text-sm text-primary-700">
                      <i className="ri-error-warning-line mr-1"></i>
                      {formError}
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-50">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            你可能有这些疑问
          </h2>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqList.map((faq, idx) => (
            <div key={idx} className="rounded-lg bg-background-100 overflow-hidden">
              <button
                onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                <i className={`ri-${openFaq === idx ? 'subtract' : 'add'}-line text-foreground-500 text-lg flex-shrink-0 transition-transform duration-200`}></i>
              </button>
              {openFaq === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}